export const getIconUrlBySubCategoryId = (subCategoryId) =>
    `https://fiverr-res.cloudinary.com/listings_assets/gq_icons/${subCategoryId}.svg`;
